var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Tooltip, FacetVisibility, TooltipInfoFacet, TooltipPlacement, UpdateFacetOnModelMessage, RemoveFacetFromModelMessage, RemoveSubModelMessage, ShowTooltipsBehavior, } from "flavr-common";
import { ChangeTooltipInfoVisibilityMessage, ChangeTooltipAnchorPointMessage } from "@messages/rendering/MeshMessages";
import { InteractionHandler } from "../Interactions";
import { ModelEventHandler, ModelEventType } from "@modules/module";
import { modelPool } from "@modules/model";
/**
 * This class is responsible for showing/hiding ToolTips, when a model with the ShowTooltips-Behavior is selected/deselected;
 */
export class ShowTooltipsInteractionHandler extends InteractionHandler {
    constructor() {
        super(ShowTooltipsBehavior.typestatic, [ShowTooltipsBehavior.typestatic], [], []);
        this.models = new Map();
        this.connection.subscribe([
            `${UpdateFacetOnModelMessage.typestatic}${TooltipInfoFacet.typestatic}`,
            `${RemoveFacetFromModelMessage.typestatic}${TooltipInfoFacet.typestatic}`,
            RemoveSubModelMessage.typestatic
        ], (msg, metaData) => {
            if (UpdateFacetOnModelMessage.is(msg)) {
                if (TooltipInfoFacet.is(msg.facet)) {
                    this.onTooltipUpdate(msg.uid, msg.facet, metaData.timeStamp);
                }
            }
            else if (RemoveFacetFromModelMessage.is(msg)) {
                if (msg.facetType === TooltipInfoFacet.typestatic) {
                    this.deleteTooltip(msg.uid, metaData.timeStamp);
                }
            }
            else if (RemoveSubModelMessage.is(msg)) {
                this.deleteTooltip(msg.uid, metaData.timeStamp);
            }
        });
    }
    handleModelTransformEvent(model, _localTransform) {
        const modelData = this.models.get(model.getUID());
        if (modelData === undefined)
            return;
        if (modelData.selectedBy.size > 0)
            return;
        const worldPosition = model.getWorldPosition();
        this.connection.send(new ChangeTooltipAnchorPointMessage(model.getUID(), worldPosition.toArray()));
    }
    onTooltipUpdate(uid, tooltip, timeStamp) {
        const existing = this.models.get(uid);
        if (existing) {
            this.syncTooltipAnchorPoint(uid, tooltip);
            if (existing.selectedBy.size > 0) {
                this.updateTooltipView(uid, existing.selectedBy, existing.tooltip, tooltip);
            }
            existing.tooltip = tooltip;
            existing.timeStamp = timeStamp;
        }
        else {
            this.syncTooltipAnchorPoint(uid, tooltip);
            this.models.set(uid, {
                timeStamp,
                tooltip,
                selectedBy: new Set(),
                isLockable: tooltip.isLockable !== undefined ? tooltip.isLockable : false,
                isLocked: false
            });
        }
    }
    updateTooltipView(uid, constrollers, oldTooltip, newTooltip) {
        if (oldTooltip.placement !== newTooltip.placement) {
            // hide old Tooltip
            if (oldTooltip.placement === TooltipPlacement.CONTROLLER) {
                this.setTooltipVisibilityForControllers(constrollers, false);
            }
            else {
                this.hideTooltipAnnotation(uid);
            }
            // show new Tooltip
            if (newTooltip.placement === TooltipPlacement.CONTROLLER) {
                this.updateTooltipForControllers(constrollers, newTooltip);
                this.setTooltipVisibilityForControllers(constrollers, true);
            }
            else {
                this.showTooltipAnnotation(uid);
            }
        }
        else {
            if (newTooltip.placement === TooltipPlacement.CONTROLLER) {
                this.updateTooltipForControllers(constrollers, newTooltip);
            }
        }
    }
    deleteTooltip(uid, timeStamp) {
        const existing = this.models.get(uid);
        if (!existing || existing.timeStamp >= timeStamp)
            return;
        if (existing.selectedBy.size > 0) {
            switch (existing.tooltip.placement) {
                case TooltipPlacement.CONTROLLER:
                    this.setTooltipVisibilityForControllers(existing.selectedBy, false);
                    break;
                case TooltipPlacement.LEFT_OF_MODEL:
                case TooltipPlacement.RIGHT_OF_MODEL:
                case TooltipPlacement.ABOVE_MODEL:
                case TooltipPlacement.BELOW_MODEL:
                    this.hideTooltipAnnotation(uid);
                    break;
            }
        }
        this.models.delete(uid);
    }
    onSelect(_, uid, controller) {
        const model = this.models.get(uid);
        if (!model)
            return;
        model.selectedBy.add(controller.uid);
        const tooltip = model.tooltip;
        switch (tooltip.placement) {
            case TooltipPlacement.CONTROLLER:
                this.updateTooltip(controller.uid, tooltip);
                this.setTooltipVisibility(controller.uid, true);
                break;
            case TooltipPlacement.LEFT_OF_MODEL:
            case TooltipPlacement.RIGHT_OF_MODEL:
            case TooltipPlacement.ABOVE_MODEL:
            case TooltipPlacement.BELOW_MODEL:
                this.syncTooltipAnchorPoint(uid, tooltip);
                model.selectedBy.size === 1 && this.showTooltipAnnotation(uid);
                break;
        }
    }
    onDeselect(_, uid, controller) {
        const model = this.models.get(uid);
        if (!model)
            return;
        model.selectedBy.delete(controller.uid);
        const tooltip = model.tooltip;
        switch (tooltip.placement) {
            case TooltipPlacement.CONTROLLER:
                this.setTooltipVisibility(controller.uid, false);
                break;
            case TooltipPlacement.LEFT_OF_MODEL:
            case TooltipPlacement.RIGHT_OF_MODEL:
            case TooltipPlacement.ABOVE_MODEL:
            case TooltipPlacement.BELOW_MODEL:
                if ((model.isLockable && !model.isLocked && model.selectedBy.size === 0) || !model.isLockable)
                    model.selectedBy.size === 0 && this.hideTooltipAnnotation(uid);
                break;
        }
    }
    onSelectButtonClick(_, uid, _controller, _hitPoint) {
        const model = this.models.get(uid);
        if (!model)
            return;
        model.isLocked = model.isLockable && !model.isLocked;
    }
    onControllerMove(_, uid, controller, hitPoint) {
        const model = this.models.get(uid);
        if (model === undefined || model.isLocked)
            return;
        if (model.tooltip.placement === TooltipPlacement.CONTROLLER)
            return;
        const firstController = model.selectedBy.values().next().value;
        if (firstController !== controller.uid) {
            return;
        }
        this.connection.send(new ChangeTooltipAnchorPointMessage(uid, hitPoint));
    }
    showTooltipAnnotation(uid) {
        this.connection.send(new ChangeTooltipInfoVisibilityMessage(uid, true));
    }
    hideTooltipAnnotation(uid) {
        this.connection.send(new ChangeTooltipInfoVisibilityMessage(uid, false));
    }
    updateTooltipForControllers(controllers, tooltip) {
        for (const ctr of controllers) {
            this.updateTooltip(ctr, tooltip);
        }
    }
    updateTooltip(controllerUId, tooltip) {
        this.connection.send(new UpdateFacetOnModelMessage(controllerUId, new Tooltip(tooltip.text, tooltip.align, tooltip.avatar)));
    }
    syncTooltipAnchorPoint(uid, tooltip) {
        if (tooltip.placement === TooltipPlacement.CONTROLLER)
            return;
        const model = modelPool.getModel(uid);
        if (model === undefined)
            return;
        this.connection.send(new ChangeTooltipAnchorPointMessage(uid, model.getWorldPosition().toArray()));
    }
    setTooltipVisibilityForControllers(controllers, visible) {
        for (const ctr of controllers) {
            this.setTooltipVisibility(ctr, visible);
        }
    }
    setTooltipVisibility(controllerUid, visible) {
        this.connection.send(new UpdateFacetOnModelMessage(controllerUid, new FacetVisibility(Tooltip, visible)));
    }
}
__decorate([
    ModelEventHandler(ModelEventType.TRANSFORM_UPDATED)
], ShowTooltipsInteractionHandler.prototype, "handleModelTransformEvent", null);
